import { createFileRoute } from "@tanstack/react-router";
import FounderApplication from "@/pages/FounderApplication";

export const Route = createFileRoute("/my-application/")({
  component: FounderApplication,
});
